type PaidBreakExceptionSummaryContentProps = {
  summaryText?: string;
};

export function PaidBreakExceptionSummaryContent({ summaryText }: PaidBreakExceptionSummaryContentProps) {
  return <p className="text-base text-on-surface-variant">{summaryText || 'See shifts for details.'}</p>;
}
